import { useMemo } from 'react'

/**
 * Hook for calculating ancillary service prices (baggage, meals, seats)
 * Takes selected ancillaries and computes the total cost for each service type
 */
const useAncillaryPricing = (selectedAncillaries: any[] = []) => {
    const { baggagePrice, mealPrice, seatPrice } = useMemo(
        () =>
            selectedAncillaries.reduce(
                (acc, ancillarySegment) => {
                    const { baggageDetails, mealDetails, seatDetails } = ancillarySegment || {}
                    const segmentBaggagePrice =
                        baggageDetails?.reduce((acc: number, baggage: any) => acc + (baggage.price || 0), 0) || 0
                    const segmentMealPrice =
                        mealDetails?.reduce((acc: number, meal: any) => acc + (meal.price || 0), 0) || 0
                    const segmentSeatPrice =
                        seatDetails?.reduce((acc: number, seat: any) => acc + (seat.price || 0), 0) || 0

                    if (segmentBaggagePrice) {
                        acc.baggagePrice += segmentBaggagePrice
                    }
                    if (segmentMealPrice) {
                        acc.mealPrice += segmentMealPrice
                    }
                    if (segmentSeatPrice) {
                        acc.seatPrice += segmentSeatPrice
                    }
                    return acc
                },
                {
                    baggagePrice: 0,
                    mealPrice: 0,
                    seatPrice: 0
                }
            ),
        [selectedAncillaries]
    )

    return {
        baggagePrice,
        mealPrice,
        seatPrice
    }
}

export default useAncillaryPricing
